// extracted by mini-css-extract-plugin
export default {"width":"div_width__cg4+n","disabled":"div_disabled__DBYyj"};